import EventBus from "@/services/EventBus.js";
import { Loader } from "@googlemaps/js-api-loader";
import MapMixinStyles from './MapMixinStyles';
import { MarkerClusterer } from "@googlemaps/markerclusterer";
import Vue from 'vue';
import AppConfig from "@/mixins/AppConfig-APP_TARGET";
import MapControls from '@/components/CX/Map/MapControls.vue';
import { i18n } from "@/i18n";
import axios from 'axios';

function TxtOverlay(pos, txt, cls, map) {
  this.pos = pos;
  this.txt_ = txt;
  this.cls_ = cls;
  this.map_ = map;
  this.div_ = null;
  this.setMap(map);
}

export default {
  props: {
    optionsData: Object,
    countryItems: Array,
    pointItems: Array,
    dashboardData: Object,
    thresholdData: Array,
    brandsData: Object,
    selectedBrand: String,
    kpi: Object
  },

  mixins: [ AppConfig ],

  components: { MapControls },

  data () {
    return {
      googleMap: null,
      markers: [],
      countryMarkers: [],
      countries: [],
      layers: [],
      mapOptions: {
        center: {
          lat: 50,
          lng: 11
        },
        zoom: 3,
        minZoom: 2,
        restriction: {
          latLngBounds: {
            north: 80,
            south: -70,
            east: 180,
            west: -180,
          },
        },
        mapTypeControlOptions: {
          mapTypeIds: ["roadmap", "satellite", "hybrid", "terrain", "blue_map", "dark_map", "silver_map"],
        }
      },
      markerClusters: null,
      styles: MapMixinStyles,
      world: null,
      showDealers: true,
    };
  },

  watch: {
    kpi: function (val, old) {
      if (this.googleMap && val !== old){
        this.paint();
      }
    },
    countryItems: function (val, old) {
      if (this.googleMap && val !== old)
        this.paint();
    },
    pointItems: function (val, old) {
      if (this.googleMap && val !== old)
        this.paintDealers();
    },
    thresholdData: function (val, old) {
      if (this.googleMap && val !== old)
        this.paintCountries();
    },
  },

  async mounted () {
    EventBus.$on("LocalizationChanged", (localizationId) => {
      this.loadMap();
    });
    EventBus.$on("show-dealers-changed2", (x) => {
      this.showDealers = (x == 'showDealers');
      this.paintDealers();
    });

    var worldGeoJson = await axios.get(`${process.env.BASE_URL}static/maps/countryPolygons.json`);
    this.world = worldGeoJson.data.features;

    this.loadMap();
  },

  beforeDestroy() {
    EventBus.$off("LocalizationChanged");
    EventBus.$off("show-dealers-changed2");
  },

  methods: {
    addCustomControls(map) {
      var MapControlsComponent = Vue.extend(MapControls);
      const instance = new MapControlsComponent({ 
        i18n,
        propsData: {
          brandsData: this.brandsData,
          thresholdData: this.thresholdData,
          selectedBrand: this.selectedBrand
        }
      });
      instance.$mount();
      map.controls[google.maps.ControlPosition.LEFT_TOP].push(instance.$el);
    },

    createLayers() {
      this.layers.forEach(ly => {
        ly.setMap(null);
      });
      this.layers = [];

      if (!this.thresholdData || this.thresholdData.length < 1)
        return;

      this.thresholdData.forEach(ly => {
        var layer = new google.maps.Data();
        layer.setStyle({
          fillColor: ly.Color,
          strokeColor: '#000',
          strokeOpacity: 0.5,
          strokeWeight: 1
        });
        layer.setMap(this.googleMap);
        
        // // Raise Event 'country clicked'
        // layer.addListener('click', (event) => {
        //   EventBus.$emit('map-country-clicked', event?.feature?.j.ISO_A2)
        // });

        this.layers.push(layer);
      });
    },

    addCenterControl(div, map) {
      const chicago = { lat: 41.85, lng: -87.65 };

      // Set CSS for the control border.
      const controlUI = document.createElement("div");

      controlUI.style.backgroundColor = "#fff";
      controlUI.style.border = "2px solid #fff";
      controlUI.style.borderRadius = "3px";
      controlUI.style.boxShadow = "0 2px 6px rgba(0,0,0,.3)";
      controlText.style.fontFamily = "'BmwCondensed',Verdana,Geneva,sans-serif";
      controlUI.style.cursor = "pointer";
      controlUI.style.marginTop = "8px";
      controlUI.style.marginBottom = "22px";
      controlUI.style.textAlign = "center";
      controlUI.title = "Click to recenter the map";
      div.appendChild(controlUI);

      // Set CSS for the control interior.
      const controlText = document.createElement("div");

      controlText.style.color = "rgb(25,25,25)";
      controlText.style.fontFamily = "'BmwCondensed',Verdana,Geneva,sans-serif";
      controlText.style.fontSize = "16px";
      controlText.style.lineHeight = "38px";
      controlText.style.paddingLeft = "5px";
      controlText.style.paddingRight = "5px";
      controlText.innerHTML = "Center Map";
      controlUI.appendChild(controlText);
      // Setup the click event listeners: simply set the map to Chicago.
      controlUI.addEventListener("click", () => {
        map.setCenter(chicago);
      });
    },

    loadMap() {
      let self = this;
      let map;
      // Sets actual localization for localized date & time and number formats
      let localization = this.getLocalization();
      let loader = new Loader({
        apiKey: this.getMapsApiKey(),
        version: "weekly",
        libraries: ['drawing', 'geometry', 'visualization'],
        region: localization.region,
        language: localization.language,
        //   installComponents: true
      });

      loader
        .load()
        .then(() => {
          // init google maps on div with id=map
          map = new google.maps.Map(document.getElementById("map"), self.mapOptions);

          // Add map styles from MapMixinStyles.js file
          for (const item of this.styles) {
            map.mapTypes.set(
              item.key,
              new google.maps.StyledMapType(item.style, { name: item.name }));
          }

          // Set active map
          map.setMapTypeId(this.styles[0].key);

          this.addCustomControls(map);

          // Listen to changes, user input
          map.addListener("zoom_changed", () => { this.mapOptions.zoom = map.getZoom();  });
          map.addListener("center_changed", () => {
            let c = map.getCenter();
            this.mapOptions.center = { lat: c.lat(), lng: c.lng() };
          });
          map.addListener("click", (event) =>
          {
            // console.log(event);
            // console.log("click")
          } );
          // map.addListener("dblclick", () => console.log("dblclick"));
          // map.addListener("rightclick", () => console.log("rightclick"));
          // map.addListener("contextmenu", () => console.log("contextmenu"));
          // map.addListener("mouseout", () => console.log("mouseout"));
          // map.addListener("mouseover", () => console.log("mouseover"));
          // map.addListener("bounds_changed", () => console.log("bounds_changed"));

          // remember maps object
          self.googleMap = map;

          this.initializeOverlays();

          // set icon for all dealers
          this.paint();
        })
        .catch(e => {
          console.error(e);
        })
        .finally(() => {

          EventBus.$emit("mapInitialized")
        });
    },

    getDealers() {
      if (this.optionsData && !_.isEmpty(this.optionsData.ClientLocations)) {
        return this.optionsData.ClientLocations.filter((dealer) => dealer.lat && dealer.lng && dealer.isActive );
      } else if (this.pointItems) {
        return this.pointItems;
      } else {
        console.error("FAIL getDealers");
        return [];
      }
    },

    getInfoWindowHtml(marker) {
      return  `<div id="content" style="font-family: 'BmwCondensed',Verdana,Geneva,sans-serif;" ><div id="siteNotice"></div><h4 id="firstHeading" class="firstHeading">${marker.raw.LocationName}</h4><div id="bodyContent"><p>` +
      `${marker.raw.Address}</br>${marker.raw.City} (${marker.raw.CountryName})</br>` +
      "</p></div></div>";
    },

    getLocalization() {
      let localization = document.querySelector('html').getAttribute('lang');
      return {
        language: localization == 'deflt' ? 'en' : localization.substring(0, 2),
        region: localization == 'deflt' ? 'GB' : localization.substring(3)
      };
    },

    initializeMap(divId) {

    },

    paint() {
      this.paintCountries();
      this.paintDealers();
    },

    getLayerIndex(country) {
      if (country.Result == null)
        return 0;

      let value = country.Result;
      let layer = this.thresholdData.find(x => x.Minimum <= value && x.Maximum >= value);
      if (!layer)
        return 0;

      return this.thresholdData.indexOf(layer);
    },

    paintCountries() {
      // if (!this.layers || this.layers.length == 0)
      this.createLayers();

      // let features = this.layers[this.getRandomInt(this.layers.length)].addGeoJson(poly, { 'idPropertyName': code });
      // google.maps.event.addListener(this.googleMap, "click", (event) => {
      //   console.log("WHOLE MAP CLICKED");
      // });
      this.country = undefined;

      if (this.countryItems && this.countryItems.length == 0)
        return;

      let self = this;
      this.countryItems.forEach(country => {
        let layerIndex = this.getLayerIndex(country);
        let countryPoly = self.world.find(x => x.properties.ISO_A2 == country.CountryId);
        let ft = this.layers[layerIndex].addGeoJson(countryPoly, { 'idPropertyName': country.CountryId });
      });

      this.googleMap.data.addListener("click", (event) => {
        // console.log(event.feature);
      });
    },

    paintCountryValues() {
      let dealersByCountry = _.groupBy(this.getDealers().filter(x => x.lat !== null && x.lng !== null), 'CountryId');
      for (let country in dealersByCountry) {
        let dealers = dealersByCountry[country];
        let countryData = this.countryItems.find(x => x.CountryId == country);

        let pos = { 
          lat: _.sumBy(dealers, 'lat') / dealers.length, 
          lng: _.sumBy(dealers, 'lng') / dealers.length
        };

        let countryValue = !countryData ? 'N/A' : Math.round(countryData.Result);
        let txt = new TxtOverlay(
          new google.maps.LatLng(pos.lat,pos.lng), 
         `<div><div><span>${country}</span></div>` +
            `<div style="position: inherit; bottom: 0px;"><span style="font-size: 1.7em; line-height: 0.8em; font-weight: 800;letter-spacing: -0.08em;">${countryValue}</span></div>` +
          '</div>', 
          "customOverlayBox", 
          this.googleMap);

        this.countryMarkers.push(txt);
      }
    },
    
    initializeOverlays() {
      let offset = { x: -20, y: -20 };

      TxtOverlay.prototype = new google.maps.OverlayView();
      TxtOverlay.prototype.onAdd = function() {
        var div = document.createElement('DIV');
        div.className = this.cls_;
        div.innerHTML = this.txt_;
      
        // Set the overlay's div_ property to this DIV
        this.div_ = div;
        var overlayProjection = this.getProjection();
        var position = overlayProjection.fromLatLngToDivPixel(this.pos);
        div.style.left = position.x + offset.x + 'px';
        div.style.top = position.y + offset.y + 'px';
        var panes = this.getPanes();
        panes.floatPane.appendChild(div);
      }
      TxtOverlay.prototype.draw = function() {
        var overlayProjection = this.getProjection();
        var position = overlayProjection.fromLatLngToDivPixel(this.pos);
        var div = this.div_;
        if (div) {
          div.style.left = position.x + offset.x + 'px';
          div.style.top = position.y + offset.y + 'px';
        }
      }
      TxtOverlay.prototype.onRemove = function() {
        try {
          this.setMap(null);
          this.div_.parentNode.removeChild(this.div_);
        } catch (error) {
        }
        this.div_ = null;
      }
      TxtOverlay.prototype.hide = function() {
        if (this.div_) {
          this.div_.style.visibility = "hidden";
        }
      }
      TxtOverlay.prototype.show = function() {
        if (this.div_) {
          this.div_.style.visibility = "visible";
        }
      }
      TxtOverlay.prototype.toggle = function() {
        if (this.div_) {
          if (this.div_.style.visibility == "hidden") {
            this.show();
          } else {
            this.hide();
          }
        }
      }
      TxtOverlay.prototype.toggleDOM = function() {
        if (this.getMap()) {
          this.setMap(null);
        } else {
          this.setMap(this.map_);
        }
      }
    },

    removeCountryValues() {
      for (const item of this.countryMarkers) {
        item.onRemove();
      }
      this.countryMarkers = [];
    },

    paintDealers() {
      let fixBmwOpt = '/static/img/pin.bmw.lg.png';
      let fixMiniOpt = '/static/img/pin.mini.lg.png';
      let fixBmwMotoOpt = '/static/img/pin.bmwmotorrad.lg.png';
      let fixIt = fixBmwMotoOpt + fixBmwOpt + fixMiniOpt;
      fixBmwMotoOpt = fixIt;
      let iconFile = `/static/img/pin.${this.selectedBrand}.lg.png`;

      this.removeClusters();
      this.removeMarkers();
      this.removeCountryValues();

      if (!this.showDealers) {
        this.paintCountryValues();
        return;
      } 

      // only use filters that have coordinates and are marked as active
      let filteredDealers = this.getDealers()
        .filter(x => x.lat !== null && x.lng !== null);

      // get marker object for each item
      this.markers = filteredDealers.map((dealer, i) => {
        return new google.maps.Marker({
          position: { lat: dealer.lat, lng: dealer.lng },
          icon: iconFile,
          icon: {
            url: iconFile, 
            // size: new google.maps.Size(200, 200),
            scaledSize: new google.maps.Size(48, 48),
            origin: new google.maps.Point(0, 0),
            anchor: new google.maps.Point(24, 48),
          },
          raw: dealer
          // title:  dealer.LocationName,
          // icon: '/static/img/icon.bmw.bw.png',
          // label: dealer.LocationName,
        });
      });

      var infowindow = new google.maps.InfoWindow({ content: "" });
      let self = this;

      for (let i = 0; i < this.markers.length; i++) {
        const marker = this.markers[i];
        marker.addListener('mouseover', function() {
          infowindow.setContent(self.getInfoWindowHtml(marker));
          infowindow.open({ anchor: marker, map: self.googleMap, shouldFocus: false });
        });

        marker.addListener('mouseout', function() {
          infowindow.close();
        });

        marker.addListener("click", (e) => {
          EventBus.$emit("mapDealerClicked", marker.raw);
        });
      }

      this.setMapOnAll(this.markers, this.googleMap);
   
      let options = { 
        algorithm: undefined,
        map: this.googleMap,
        markers: this.markers,
        renderer: undefined, //this.niceRender,
        onClusterClick: undefined,
        gridSize: 50,
        // styles: clusterStyles,
        maxZoom: 15,
        imagePath: `/static/img/maps/maps-cluster-marker-default`,
        minimumClusterSize: 4
      };

      this.markerClusters = new MarkerClusterer(options); // , ...this.getMarkerClustererOptions()
      // this.markerClusters = new MarkerClusterer({ mp, mk, ...this.getMarkerClustererOptions()});
    },

    niceRender({ count, position }, stats) {
      // change color if this cluster has more markers than the mean cluster
      const color = count > Math.max(10, stats.clusters.markers.mean) ? "#ff0000" : "#0000ff";
      // create svg url with fill color
      const svg = window.btoa(`
<svg fill="${color}" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 240">
  <circle cx="120" cy="120" opacity=".6" r="70" />
  <circle cx="120" cy="120" opacity=".3" r="90" />
  <circle cx="120" cy="120" opacity=".2" r="110" />
</svg>`);
      // create marker using svg icon
      return new google.maps.Marker({
          position,
          icon: {
              url: `data:image/svg+xml;base64,${svg}`,
              scaledSize: new google.maps.Size(45, 45),
          },
          label: {
              text: String(count),
              color: "rgba(255,255,255,0.9)",
              fontSize: "12px",
          },
          title: `Cluster of ${count} markers`,
          // adjust zIndex to be above other markers
          zIndex: Number(google.maps.Marker.MAX_ZINDEX) + count,
      });
  },

    removeClusters() {
      // remove all clusters
      if (this.markerClusters) {
        this.markerClusters.setMap(null);
        this.markerClusters = null;
      }
    },

    removeMarkers() {
      // remove all markers
      if (!_.isEmpty(this.markers)) {
        this.setMapOnAll(this.markers, null);
        this.markers = [];
      }
    },

    setMapOnAll(markers, map) {
      for (let i = 0; i < markers.length; i++) {
        // if (this.googleMap) {
        //   this.googleMap.event.clearInstanceListeners(markers[i]);
        // }
        markers[i].setMap(map);
      }
    },

  }
};
